// src/app/shared/services/seo.service.ts

import {Inject, Injectable} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {DOCUMENT} from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class SeoService {

    constructor(private titleService: Title, private metaService: Meta, @Inject(DOCUMENT) private doc: Document) {
    }

    updateMetaData(config: { title: string; description: string; canonical?: string }) {
        // Title
        this.titleService.setTitle(config.title);

        // Description
        this.metaService.updateTag({
            name: 'description',
            content: config.description
        });

        // Canonical
        this.setCanonicalUrl(config.canonical || this.doc.URL);
    }

    private setCanonicalUrl(url: string) {
        let link: HTMLLinkElement | null = this.doc.querySelector("link[rel='canonical']");
        if (link) {
            link.setAttribute('href', url);
        } else {
            link = this.doc.createElement('link');
            link.setAttribute('rel', 'canonical');
            link.setAttribute('href', url);
            this.doc.head.appendChild(link);
        }
    }
}
